@import "../../../../common/_base";

// Must be placed after the ":where(a, button)"
@include button-reset();
@include box-sizing();

:host {
  display: grid;
}

.expandable-button {
  justify-content: center;
  align-self: center;
}

// TODO: Add a unit test for this
.ch-disabled {
  pointer-events: none;
}

// Remove focus of the button content
// TODO: Is this necessary?
::slotted([slot="action"]) {
  pointer-events: none;
}

// - - - - - - - - - - - - - - - -
//           Separation
// - - - - - - - - - - - - - - - -
ch-popover {
  --ch-popover-separation-x: var(--ch-action-menu-separation-x);
  --ch-popover-separation-y: var(--ch-action-menu-separation-y);

  &:not(.hydrated) {
    display: none;
    opacity: 0;
  }
}

// Dummy separation to keep opened the popup when expand-behavior === "ClickOrHover"
// ch-window[y-align="outside-start"] {
//   --ch-window-separation: var(--separation-y);
//   --ch-window-separation-y: calc(var(--separation-y) * -1);
// }

// ch-window[y-align="outside-end"] {
//   --ch-window-separation: var(--separation-y);
//   --ch-window-separation-y: var(--separation-y);
// }

// ch-window[x-align="outside-start"] {
//   --ch-window-separation: var(--separation-x);
//   --ch-window-separation-x: calc(var(--separation-x) * -1);
// }

// ch-window[x-align="outside-end"] {
//   --ch-window-separation: var(--separation-x);
//   --ch-window-separation-x: var(--separation-x);
// }

// - - - - - - - - - - - - - - - -
//             Images
// - - - - - - - - - - - - - - - -
.action {
  text-align: start;

  --ch-action-menu-item-start-img: var(--ch-start-img--base);
  --ch-action-menu-item-end-img: var(--ch-end-img--base);

  &.start-img--hover:hover {
    --ch-action-menu-item-start-img: var(--ch-start-img--hover);
  }
  &.end-img--hover:hover {
    --ch-action-menu-item-end-img: var(--ch-start-end--hover);
  }

  &.start-img--active:active {
    --ch-action-menu-item-start-img: var(--ch-start-img--active);
  }
  &.end-img--active:active {
    --ch-action-menu-item-end-img: var(--ch-start-end--active);
  }

  &.start-img--focus:focus {
    --ch-action-menu-item-start-img: var(--ch-start-img--focus);
  }
  &.end-img--focus:focus {
    --ch-action-menu-item-end-img: var(--ch-end-img--focus);
  }

  &.start-img--disabled.ch-disabled {
    --ch-action-menu-item-start-img: var(--ch-start-img--disabled);
  }
  &.end-img--disabled.ch-disabled {
    --ch-action-menu-item-end-img: var(--ch-end-img--disabled);
  }
}

.pseudo-img--start::before,
.pseudo-img--end::before {
  content: "";
  display: block;
  inline-size: var(--ch-action-menu-item__image-size);
  block-size: var(--ch-action-menu-item__image-size);
  min-inline-size: var(--ch-action-menu-item__image-size);
}

// Background
.start-img-type--background::before {
  background: no-repeat center /
    var(--ch-action-menu-item__background-image-size)
    var(--ch-action-menu-item-start-img);
}
.end-img-type--background::after {
  background: no-repeat center /
    var(--ch-action-menu-item__background-image-size)
    var(--ch-action-menu-item-end-img);
}

// Mask
.start-img-type--mask::before {
  -webkit-mask: no-repeat center /
    var(--ch-action-menu-item__background-image-size)
    var(--ch-action-menu-item-start-img);
  background-color: currentColor;
}
.end-img-type--mask::after {
  -webkit-mask: no-repeat center /
    var(--ch-action-menu-item__background-image-size)
    var(--ch-action-menu-item-end-img);
  background-color: currentColor;
}

.content {
  inline-size: 100%;
}
